import { Button, CheckboxCard, CheckboxWrapper } from '@design-system';
import { useTranslation } from 'next-i18next';
import { useState } from 'react';

import { SimpleDialog } from '../../../Dialog/SimpleDialog';
import { CardBrand } from '../../../Payments/CardBrand';
import { DetailsCard } from '../types';
import { formatMaskedCardNumber } from '../utils/format';
import { AddNewRow } from './AddNewRow';

export type SelectCardDialogProps = {
  cards: DetailsCard[];
  selectedCardId?: string;
  onSave: (cardId: string) => void;
  onAddNew: () => void;
  onClose: () => void;
};

export const SelectCardDialog = ({
  cards,
  onAddNew,
  onClose,
  onSave,
  selectedCardId,
}: SelectCardDialogProps) => {
  const { t } = useTranslation('checkout');
  const [draftId, setDraftId] = useState(selectedCardId);

  return (
    <SimpleDialog
      centered
      onClose={onClose}
      open
      title={t('details.paymentCard.selectTitle')}
    >
      <div className="flex flex-col gap-3 pt-1">
        <CheckboxWrapper hideLabel>
          {cards.map((card) => (
            <CheckboxCard
              key={card.id}
              checked={draftId === card.id}
              id={`details-card-${card.id}`}
              label={formatMaskedCardNumber(card.last4)}
              name="details-card"
              onChange={() => setDraftId(card.id)}
              suffix={<CardBrand brand={card.brand} />}
              type="radio"
              value={card.id}
            />
          ))}
        </CheckboxWrapper>

        <AddNewRow label={t('details.paymentCard.addNew')} onClick={onAddNew} />

        <Button
          disabled={!draftId}
          fullWidth
          label={t('details.save')}
          onClick={() => draftId && onSave(draftId)}
          variant="primary"
        />
      </div>
    </SimpleDialog>
  );
};
